import { Classroom } from '@teetsh/app/src/types/classroom';
import { CJEvent, CJFilterStatus } from '@teetsh/app/src/types/event';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { getDayOfCahierJournal } from '@teetsh/app/src/containers/CahierJournal/utils/getDayOfCahierJournal';
import { ClassroomWithGroupeEvent } from 'types/cj';

function shouldFilterEvent(evt: CJEvent, status: CJFilterStatus) {
  if (status === 'all') {
    return true;
  }
  return status === evt.status;
}

export function getClassroomsWithEvents(
  classrooms: Classroom[],
  events: CJEvent[],
  status: CJFilterStatus,
  day: Date,
  classroomsOrg: ClassroomsOrg,
): (ClassroomWithGroupeEvent & {
  eventsToDisplay: CJEvent[][][];
})[] {
  const dayWithEvents = getDayOfCahierJournal({
    seances: (events || []).filter(evt => shouldFilterEvent(evt, status)),
    classrooms,
    day,
    classroomsOrg,
  });

  return (dayWithEvents?.classrooms || []).map(c => ({
    ...c,
    eventsToDisplay: [...(c.groupedEvents || [])],
  }));
}
